import React from 'react';
import { registrationApi } from '../../../actions/registration';
import EventAvailability from './Availability';
import styles from './styles.css';

class RegistrationCard extends React.Component {
  state = {
    isRegistered: false,
  };
  componentDidMount() {
    this.checkRegistered();
  }

  componentDidUpdate(prevProps) {
    const { currentUser: { id: oldUserId } = {} } = prevProps;
    const { currentUser: { id: newUserId } = {} } = this.props;

    if (oldUserId !== newUserId) {
      this.checkRegistered();
    }
  }

  checkRegistered = () => {
    const {
      event: { key: eventKey } = {},
      currentUser: { id: individualKey } = {},
    } = this.props;

    // if this was called verify it, the call should be fast enough that it doesn't matter
    if (individualKey && eventKey) {
      // call the api because we don't need this is global state
      registrationApi
        .get(null, {
          params: {
            eventKey,
            individualKey,
          },
        })
        .then(
          ({ resp }) => {
            // if it did error out then they are registered
            this.setState({ isRegistered: resp.ok });
          },
          () => {
            //no-op on failure
          }
        );
    }
  };

  render() {
    return (
      <div className={styles['reg-form']}>
        <EventAvailability {...this.props} {...this.state} />
      </div>
    );
  }
}

export default RegistrationCard;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/index.js